import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const StyledButton = styled.button`
  &&& {
    display: inline-block;
    min-height: 29px;
    min-width: 110px;
    color: #fff;
    margin: 5px;
  }
  &&&.big {
    font-size: 18px;
    padding: 0 30px;
    text-align: center;
    min-width: 140px;
    line-height: 45px;
  }
  &&&.small {
    min-width: 80px;
    height: 34px;
    font-size: 13px;
    margin: 0px;
  }
  &&&:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

const ButtonSpinner = styled.span`
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-left: 8px;
  vertical-align: middle;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top: 2px solid #fff;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const FunctionButton = ({
  className = "",
  value,
  onClick,
  style = {},
  loading = false,
}) => {
  const hasBgClass = /\bbg_\w+\b/.test(className);
  const computedClassName = hasBgClass
    ? className
    : `bg_blue ${className}`.trim();

  return (
    <StyledButton
      className={computedClassName}
      onClick={onClick}
      aria-label="Function Button"
      style={style}
      disabled={loading}
    >
      {value}
      {loading && <ButtonSpinner aria-hidden="true" />}
    </StyledButton>
  );
};

export default FunctionButton;
